var React = require('react');

function Plus (props) {
    return React.createElement("svg",props,[React.createElement("style",{"key":0},".st0{fill:#e0bd69}"),React.createElement("path",{"className":"st0","d":"M2.76 44.07c5.71-2.46 8.18-1.57 32.15-1 10.32.24 40.55-4.35 49.66-3.34s9.98 5.06 12 7.09c2.02 2.02 7.2 8.31-10.01 7.3 0 0-60.87-3.15-74.03 1.91 0 0-5.06.27-8.1-2.77s-6.96-8-1.85-8.99","key":1}),React.createElement("path",{"className":"st0","d":"M54.75 4.05c2.46 5.71.16 11.91 2.64 32.24 1.25 10.25-2.27 37.09-3.29 46.2s-.66 13.8-2.68 15.83-8.71-2.62-8.68-9.67c0 0 4.39-56.87.43-75.91-.63-3.01-.05-6.16 1.66-8.72.34-.52.74-1.02 1.19-1.48 1.13-1.16 6.66-2.84 8.54 1.34","key":2})]);
}

Plus.defaultProps = {"version":"1.1","id":"Layer_1","x":"0","y":"0","viewBox":"0 0 98.9 100","xmlSpace":"preserve"};

module.exports = Plus;

Plus.default = Plus;
